import type { DrawerProps } from '@mantine/core'

import type { FileItemAction } from '../../types'
import type { UploadCapture } from '../UploadManage'
import type { FileOperationOption } from './types'

export const SELECT_FILE_UPLOAD_OPTIONS: {
    label: string
    capture?: UploadCapture
    accept?: string
}[] = [
    {
        label: 'photograph',
        capture: 'environment',
        accept: 'image/*'
    },
    {
        label: 'selectFromGallery',
        accept: 'image/*'
    },
    {
        label: 'localFiles',
        accept: '*'
    }
]

export const SELECT_VIDEO_UPLOAD_OPTIONS: {
    label: string
    capture?: UploadCapture
    accept?: string
}[] = [
    {
        label: 'recordVideo',
        capture: 'environment',
        accept: 'video/*'
    },
    {
        label: 'selectFromGallery',
        accept: 'video/*'
    },
    {
        label: 'localFiles',
        accept: '*'
    }
]

export const FileItemActionLabelMap: Record<
    FileItemAction,
    {
        label: string
        icon: string
    }
> = {
    download: {
        label: 'download',
        icon: 'ArrowLineDown'
    },
    preview: {
        label: 'view',
        icon: 'NoHide'
    },
    remove: {
        label: 'delete',
        icon: 'Trash'
    }
}

export const FILE_OPERATION_OPTIONS: FileOperationOption[] = [
    {
        label: FileItemActionLabelMap['download'].label,
        value: 'download'
    },
    {
        label: FileItemActionLabelMap['preview'].label,
        value: 'preview'
    },
    {
        label: FileItemActionLabelMap['remove'].label,
        value: 'remove'
    }
]
